import { render, staticRenderFns } from "./UIPostTickerCard.vue?vue&type=template&id=186ab668&scoped=true"
import script from "./UIPostTickerCard.vue?vue&type=script&lang=js"
export * from "./UIPostTickerCard.vue?vue&type=script&lang=js"
import style0 from "./UIPostTickerCard.vue?vue&type=style&index=0&id=186ab668&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ab668",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default,TruncateParagraph: require('/skade-pwa/components/ui/atom/TruncateParagraph.vue').default,ChangePercent: require('/skade-pwa/components/ui/atom/ChangePercent.vue').default})
